var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"Hyc_SblcdStmq_A5PwBFk"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["boalingua-cms-ssr@django-stars"]={id:"Hyc_SblcdStmq_A5PwBFk"};
      